export default __webpack_public_path__ + "static/media/collections_4.e9f1a9f4.webp";